<style>
    h2,
    h3,
    h4 {
        color: var(--app-brand-cyan) !important;
    }
</style>
<div class="modal-header-custom d-flex flex-row">
    <mat-icon (click)="close()" class="close">close</mat-icon>
</div>
<h2></h2>
<h3></h3>
<h4></h4>
<mat-dialog-content>
    <div style="color: white !important;" [innerHTML]="TermsAndConditionsText">

    </div>
</mat-dialog-content>
